import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { SEEKBAR_OFFSET } from './icons.constants';

export const ANYFEED_TABLET_BREAKPOINT = '1080px';

export const PLAYER_Z_INDEX = {
  EXTERNAL: 1300,
  COVER_LOADER: 1250,
  CONTAINER: 1200,
  WRAPPER: 1100,
  CONTROLS_WRAPPER: 800,
  OVERLAY_WRAPPER: 1050,
  BUTTONS_WRAPPER: 1000,
  BUTTON: 2
};

export const TEXT_TRACK_STYLE = `
& .vjs-text-track-display {
  & .vjs-text-track-cue {
    & div {
      background-color: transparent !important;
      font-weight: bolder;
      text-shadow: #000000 0px 0px 7px;
      color: #ffffff;
    }
  }
}
`;

export const VIDEO_SPINNER_STYLE = `
  & .vjs-loading-spinner {
    border: 5px solid rgb(255 255 255 / 50%) !important;
    opacity: 1 !important;
    &:before {
      border-top-color: var(--color-i-icon-gold) !important;
      margin: -5px !important;
    }
    &:after {
      border-top-color: var(--color-i-icon-gold) !important;
      margin: -5px !important;
    }
  }
`;

export const BIG_PLAY_BUTTON_STYLE = `
& .vjs-big-play-button {
  z-index: ${PLAYER_Z_INDEX.WRAPPER};
  background: none;
  border: none;
  & .vjs-icon-placeholder {
    &:before {
      content: "";
      position: relative;
      left: 0;
      right: 0;
      cursor: pointer;
      background-size: 48px 48px;
      display: inline-block;
      width: 48px;
      height: 48px;
      background-repeat: no-repeat;
      background-image: url('/static/images/play.svg');
    }
  }
}
`;

export const VOLUME_PANEL_STYLE = `
& .vjs-volume-panel {
  position: absolute;
  bottom: 19px;
  left: 146px;
  align-items: center;
  padding-top: 3px;
  padding-bottom: 4px;
  padding-left: 6px;
  height: 38px;
  width: 38px;
  max-width: 38px;
  &:hover {
    background: var(--color-i-icon-dark-supporting);
    border-radius: 100%;
  }
  ${mediaQuery.uptoTablet} {
    display:none;
  }
  & .vjs-mute-control {
    & .vjs-icon-placeholder {
      &:before {
        content: "";
        background-size: 32px 32px;
        display: inline-block;
        position: absolute;
        width: 32px;
        height: 32px;
        background-repeat: no-repeat;
        background-image: url(/static/images/volume-high.svg);
      }
    }
  }
  & .vjs-vol-0 {
    & .vjs-icon-placeholder {
      &:before {
    content: "" !important;
    background-image: url(/static/images/mute.svg) !important;
      }
    }
  }
  & .vjs-vol-1 {
    & .vjs-icon-placeholder {
      &:before {
    content: "" !important;
    background-image: url(/static/images/volume-low.svg) !important;
      }
    }
  }
  & .vjs-vol-2 {
    & .vjs-icon-placeholder {
      &:before {
    content: "" !important;
    background-image: url(/static/images/volume-high.svg) !important;
      }
    }
  }
  & .vjs-volume-control {
    margin-bottom: 0px;
    margin-left: 8px;
    &.vjs-volume-horizontal {
      height: 3px !important;
      width: 7rem !important;
    }
    & .vjs-volume-bar {
      margin: 0 !important;
      width: 8em;
      & .vjs-mouse-display {
        left: 0px;
        min-width: 35px !important;
        background: none !important;
        height: 1px;
        & .vjs-volume-tooltip{
          padding: ${Spacings.SPACING_1B}!important;
          font-weight: ${Fonts.SEMIBOLD};
          background-color: white;
          color: var(--color-i-icon-dark-button);
          display: none;
        }
      }
      & .vjs-volume-level {
        background-color: var(--color-i-icon-tacha) !important;
        border-radius: 4px;
        &:before {
          content: "";
          background-size: 16px 16px;
          display: inline-block;
          width: 16px;
          height: 16px;
          top: -0.4rem !important;
          background-repeat: no-repeat;
          background-image: url(/static/images/progressIcon.svg);
        }
      }
    }
  }
}
`;

export const TIME_DISPLAY_STYLE = `
& .vjs-current-time {
  display: block !important;
  font-weight: ${Fonts.SEMIBOLD};
  position: absolute;
  bottom: 60px;
  right: 60px;
  font-size: 12px;
  & .vjs-current-time-display {
    &::selection {
      color: var(--color-i-all-black);
      background: var(--color-i-icon-light-tertiary);
    }
  }

  ${mediaQuery.uptoMobile} {
    bottom: 36px;
  }
}
& .vjs-time-divider {
  display: block !important;
  position: absolute;
  font-size: 12px;
  font-weight: ${Fonts.SEMIBOLD};
  bottom: 54px;
  right: 49px;
  padding-left: 12px !important;
  padding-right: 12px !important;
  & span {
        &::selection {
      color: var(--color-i-all-black);
      background: var(--color-i-icon-light-tertiary);
    }
  }
  ${mediaQuery.uptoMobile} {
    bottom: 30px;
  }
}
& .vjs-duration {
  display: block !important;
  right: 15px;
  position: absolute;
  font-size: ${Fonts.H7};
  bottom: 60px;
  font-weight: ${Fonts.SEMIBOLD};
  & .vjs-duration-display {
    &::selection {
      color: var(--color-i-all-black);
      background: var(--color-i-icon-light-tertiary);
    }
  }
  ${mediaQuery.uptoMobile} {
    bottom: 36px;
  }
}
& .vjs-remaining-time {
  display: none;
}
& .vjs-playback-rate {
  display: none;
}
`;

const PLAY_PROGRESS_STYLE = `
& .vjs-play-progress {
  background: var(--color-i-icon-tacha);
  height: 6px;
  display: block;
  position: absolute;
  border-radius: 10px;
  &:before {
    content: '';
    background-size: 20px 20px;
    display: inline-block;
    top: -0.95em;
    right: -0.4em;
    position: absolute;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-image: url('/static/images/progressIcon.svg');
  }
  & .vjs-time-tooltip {
    min-width: 50px !important;
    font-size: 12px;
    display: none;
  }
  &:hover {
    & .vjs-play-progress {
      &:before {
        margin-top: 2px;
        margin-right: 2px;
      }
    }
  }
}
`;

export const PROGRESS_CONTROL_STYLE = `
& .vjs-progress-control {
  position: absolute;
  width: calc(100% - ${SEEKBAR_OFFSET}px);
  bottom: 68px;
  padding: 0px;
  margin-left: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_6};
  border-radius: 10px;
  ${mediaQuery.uptoMobile} {
    bottom: 44px;
  }
  ${PLAY_PROGRESS_STYLE}
  & .vjs-load-progress {
    border-radius: 10px;
    background: var(--color-i-icon-loader);
    & > div {
      border-radius: 10px;
      background: transparent;
    }
  }
    & .vjs-progress-holder {
      margin: 0 6px 0 10px !important;
      &:focus {
        box-shadow: none !important;
      }
      height: 6px;
      background: var(--color-i-icon-progress);
      font-size: 0.8em !important;
      border-radius: 10px;
    }
    & .vjs-mouse-display {
      & .vjs-time-tooltip {
        min-width: 50px !important;
        font-size: 12px;
        font-weight: ${Fonts.SEMIBOLD};
        background-color: white !important;
        color: var(--color-i-icon-dark-button) !important;
      }
    }
  }
}
`;
